import React, { Component } from "react";
import {Modal,ModalBackground, ModalCard, ModalCardBody,ModalCardTitle,ModalCardHeader,Delete} from 'bloomer'
import PropTypes from "prop-types";


class ModalComponent extends Component {
  render() {
    const {children,isActive,title,onClose} = this.props;
    return (
      <Modal style={{zIndex:1000}} isActive={isActive}>
        <ModalBackground onClick={onClose} />
        <ModalCard>
          <ModalCardHeader>
            <ModalCardTitle>{title}</ModalCardTitle>
            <Delete onClick={onClose} />
          </ModalCardHeader>
          <ModalCardBody>
            {children}
          </ModalCardBody>
        </ModalCard>
      </Modal>
    )

  }
}

ModalComponent.propTypes = {
  isActive:PropTypes.bool,
  onClose:PropTypes.func,
  title:PropTypes.string,
};
ModalComponent.defaultProps = {};

export default ModalComponent;

